document.addEventListener('DOMContentLoaded', function() {
  window.expivi._events.onChange.subscribe(function(e) {
    if (e.name === "fully_loaded") {
      // Get URL params
      const urlParams = new URLSearchParams(window.location.search);
      const quantity = urlParams.get('quantity');
      const color = urlParams.get('color');

      // Handle quantity
      if (quantity) {
        const value = parseInt(quantity, 10);

        if (!isNaN(value)) {
          expivi.setProductAttributeByKey('att-quantity', {
            0: { value: value }
          });
        }
      }

      // Handle color
      if (color) {
        const formattedColor = color
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        expivi.setProductAttributeNamed('Underlay colors', formattedColor);
      }
    }
  });
});
